interface IPlatformConfig {
    name: string;
    imageURL: string
}

export const PLATFORM_LIST: IPlatformConfig[] = [
    {
        name: 'windows',
        imageURL: process.env.PUBLIC_URL + '/images/platforms/icon_platform_win.png'
    },
    {
        name: 'mac',
        imageURL: process.env.PUBLIC_URL + '/images/platforms/icon_platform_mac.png'
    },
    {
        name: 'linux',
        imageURL: process.env.PUBLIC_URL + '/images/platforms/icon_platform_steam.png'
    }
]